export default "__VITE_ASSET__BkT6HDQq__"